<script lang="ts">
    import { Checkbox } from './Checkbox';
    import { onMount, afterUpdate } from 'svelte';
    import type { ModeType } from './types';

    export let label: string = 'My Svelte Checkbox';
    export let checked: boolean = false;
    export let disabled: boolean = false;
    export let mode: ModeType = 'black-checkbox';
    export let onChange: (checked: boolean) => void = () => {};

    let root: HTMLDivElement;

    let checkbox = Checkbox(
        {
            label,
            checked,
            disabled,
            mode,
        },
        {
            onChange: ch => {
                checked = ch;
                onChange(ch);
            },
        }
    );

    onMount(() => {
        root.appendChild(checkbox.element);
    });

    afterUpdate(() => {
        checkbox.setChecked(checked);
        checkbox.setEnabled(!disabled);
        checkbox.setLabel(label);
    });

    $: {
        checkbox.setChecked(checked);
        checkbox.setEnabled(!disabled);
        checkbox.setMode(mode);
    }
</script>

<div bind:this={root} on:click on:change data-disabled={disabled ? 'true': 'false'} data-checked={checked ? 'true':'false'}></div>

<style>
    :global(.checkbox-eye-label) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
